// ADDED
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import { ImageViewModal } from "../../../../../common/Modal";
import { StatusBadge } from "../../../../../common/Badge";

const ChangeScheduleHistory = ({ isOpen, onClose, data = [] }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [viewer, setViewer] = useState({ isOpen: false, data: null });

  if (!isOpen) return null;

  const headers = ["Ref No.", "From", "To", "Shift From", "Shift To", "Status", "File"];
  const accessors = ["referenceNumber", "dateFrom", "dateTo", "shiftScheduleFromShiftName", "shiftScheduleToShiftName", "status", "content"];

  const customRender = (row, accessor) => {
    if (accessor === "referenceNumber") return `CS-${row[accessor]?.toString().padStart(6, "0")}`;
    if (accessor === "dateFrom" || accessor === "dateTo") return row[accessor] ? new Date(row[accessor]).toLocaleDateString() : "-";
    if (accessor === "status") return <StatusBadge status={row[accessor]} />;
    if (accessor === "content") {
      return row[accessor] ? (
        <button onClick={() => setViewer({ isOpen: true, data: row.content })} className="text-blue-500 bg-transparent border-none cursor-pointer">
          <AttachFileIcon fontSize="small" />
        </button>
      ) : "-";
    }
    return null;
  };

  return (
    <>
      <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3">
        <div className="bg-gray-50 w-full md:w-[95%] rounded-lg shadow-xl max-h-[90vh] flex flex-col">
          <div className="flex justify-between items-center px-6 py-3 border-b bg-white rounded-t-lg">
            <h2 className="text-xl font-semibold text-gray-500">Change Schedule History</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-700 bg-transparent border-none cursor-pointer"><CloseIcon /></button>
          </div>
          <div className="p-6 overflow-y-auto">
            <CreateTable
              headers={headers} accessors={accessors} data={data}
              currentPage={currentPage} setCurrentPage={setCurrentPage}
              itemsPerPage={10} totalItems={data.length} customCellRenderer={customRender}
            />
          </div>
        </div>
      </div>
      <ImageViewModal isOpen={viewer.isOpen} onClose={() => setViewer({ ...viewer, isOpen: false })} fileData={viewer.data} fileType="image/jpeg" />
    </>
  );
};

export default ChangeScheduleHistory;